export const JSON_PRETTY = 4;

/**
 * Json stringifier build to avoid json circular values
 * @param _data
 * @param space
 * @return {string}
 */
export const stringify = (_data: any, space: any = null) => {
    let cache: any = [];

    if (typeof space === 'number') {
        space = ''.padEnd(space);
    }

    if (_data.toJSON) {
        _data = _data.toJSON(space);
    } else if (_data.toJS) {
        _data = _data.toJS();
    }

    const data = JSON.stringify(
        _data,
        (key, value) => {
            if (key.startsWith('_')) {
                return undefined;
            }

            if (typeof value === 'object' && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    if (value.toJSON) {
                        value = value.toJSON();
                    } else if (value.toJS) {
                        value = value.toJS();
                    }

                    try {
                        return JSON.parse(
                            JSON.stringify(
                                value,
                                (k, v) => {
                                    if (k.startsWith('_')) {
                                        return undefined;
                                    }

                                    if (v && v.toJSON) {
                                        return v.toJSON();
                                    }

                                    if (v && v.toJS) {
                                        return v.toJS();
                                    }

                                    return v;
                                },
                                space,
                            ),
                        );
                    } catch (error) {
                        return '[JSON circular]';
                    }
                }

                cache.push(value);
            }

            return value;
        },
        space,
    );

    cache = null;

    return data;
};

/**
 *
 * @param data
 */
export const toJS = (data: any) => JSON.parse(stringify(data));
